
import { createAction, props } from "@ngrx/store";
import { IWarehouse } from "../models/warehouses.models";
import { IPageCount } from "src/app/shared/models/page.model";
import { APIResponse } from "src/app/core/models/api-response";

// fetch all warehouses
export const FetchAllWarehouses = createAction(
  '[ Warehouses ] - FetchAllWarehouses',
  props<{ pagination: IPageCount }>()
);

export const FetchAllWarehousesSuccess = createAction(
  '[ Warehouses ] - FetchAllWarehouses Success ',
  props<{ warehouses: APIResponse<IWarehouse> }>()
);

export const FetchAllWarehousesError = createAction(
  '[ Warehouses ] - FetchAllWarehouses Error',
);

export const SetWarehousesLoader = createAction(
  '[ Warehouses ] - SetLoading',
  props<{ isLoading: boolean }>()
);

export const LoadMoreWarehouses = createAction(
  '[ Warehouses ] - LoadMoreWarehouses',
  props<{ pagination: IPageCount }>()
);

export const LoadMoreWarehousesSuccess = createAction(
  '[ Warehouses ] - LoadMoreWarehouses Success',
  props<{ warehouses: APIResponse<IWarehouse> }>()
);

export const LoadMoreWarehousesError = createAction(
  '[ Warehouses ] - LoadMoreWarehouses Error',
);

// Add Warehouse
export const AddWarehouse = createAction(
  '[ Warehouses ] - AddWarehouse',
  props<{ warehouse: Omit<IWarehouse, 'id'> }>()
);

export const AddWarehouseSuccess = createAction(
  '[ Warehouses ] - AddWarehouse Success',
  props<{ warehouse: IWarehouse }>()
);
export const AddWarehouseError = createAction('[ Warehouses ] - AddWarehouse Error');

// Update Warehouse
export const UpdateWarehouse = createAction(
  '[ Warehouses ] - UpdateWarehouse',
  props<{ id: number; warehouse: Partial<IWarehouse> }>()
);

export const UpdateWarehouseSuccess = createAction(
  '[ Warehouses ] - UpdateWarehouse Success',
  props<{ warehouse: IWarehouse }>()
);

export const UpdateWarehouseError = createAction(
  '[ Warehouses ] - UpdateWarehouse Error',
);

// Delete Warehouse
export const DeleteWarehouse = createAction(
  '[ Warehouses ] - DeleteWarehouse',
  props<{ id: number }>()
);

export const DeleteWarehouseSuccess = createAction(
  '[ Warehouses ] - DeleteWarehouse Success',
  props<{ id: number }>()
);

export const DeleteWarehouseError = createAction(
  '[ Warehouses ] - DeleteWarehouse Error'
);

export const SetWarehousesSavingLoader = createAction(
  '[ Warehouses ] - SetSavingLoader',
  props<{ isSaving: boolean }>()
);
